/**
 * **경로 → 화면 id 표 — 자동 생성** (`node tools/analytics/gen-catalog.mjs --write`). 손으로 고치지 마라.
 * 원천은 `artifacts/feature-map/features/<id>.md` 의 `routes:` 다. feature 를 등록하면 재생성한다(⑥-c 게이트).
 * `routes_prefix:`(auth·admin)는 `<prefix>/**`(그 아래 전부)로 들어간다 — feature-map-check 의 «실효 집합»과 같다.
 */

import type { AnalyticsPage } from 'src/types/analytics/events';

/** [route 패턴, 화면 id] — 동적 마디는 `[id]` 그대로 · `**` 는 그 아래 전부. 맞추는 규칙은 `lib/analytics/page-of-path` */
export const ANALYTICS_PAGE_ROUTES: ReadonlyArray<readonly [string, AnalyticsPage]> = [
  ['/', 'home-landing'],
  ['/account/subscription', 'account'],
  ['/admin/**', 'admin'],
  ['/ads/similar-sponsored-creators', 'ads'],
  ['/ask', 'find'],
  ['/auth/**', 'auth'],
  ['/embed/external-dashboard', 'widget'],
  ['/error/403', 'error-pages'],
  ['/error/404', 'error-pages'],
  ['/error/500', 'error-pages'],
  ['/expired', 'expired'],
  ['/features', 'marketing-site'],
  ['/guide', 'guide'],
  ['/guide/[id]', 'guide'],
  ['/insight', 'marketing-site'],
  ['/intro', 'marketing-site'],
  ['/lp/a', 'home-landing'],
  ['/lp/b', 'home-landing'],
  ['/mcp', 'marketing-site'],
  ['/mcp-connect', 'settings'],
  ['/post', 'post-viewer'],
  ['/post/[id]', 'post-viewer'],
  ['/search', 'marketing-site'],
  ['/service', 'find'],
  ['/service/ai-chat', 'search-all'],
  ['/service/beta/external-dashboard', 'widget'],
  ['/service/brand-shop', 'brand-shop'],
  ['/service/competitor', 'competitor-tracking'],
  ['/service/discover/bookmarks', 'bookmark'],
  ['/service/discover/bookmarks/[id]', 'bookmark'],
  ['/service/discover/brands', 'brand-hub'],
  ['/service/discover/contents', 'search-all'],
  ['/service/discover/creators', 'creator-hub'],
  ['/service/expired', 'expired'],
  ['/service/idea', 'idea'],
  ['/service/influencer', 'influencer'],
  ['/service/insight', 'today-insight'],
  ['/service/jobs', 'jobs'],
  ['/service/labs/advanced-search', 'labs-advanced-search'],
  ['/service/labs/content-ideation', 'content-ideation'],
  ['/service/labs/content-planner', 'content-planner'],
  ['/service/labs/content-planner/[personaId]', 'content-planner'],
  ['/service/labs/content-planner/[personaId]/[channelId]', 'content-planner'],
  ['/service/labs/deep-analysis', 'data-stats'],
  ['/service/labs/link-tracking', 'tracking-link'],
  ['/service/labs/mention-stats', 'labs-stats'],
  ['/service/labs/post-analysis', 'post-analysis'],
  ['/service/labs/post-analysis/[id]', 'post-analysis'],
  ['/service/labs/widgets', 'widget'],
  ['/service/market-research', 'market-research'],
  ['/service/noticeHelper', 'workspace'],
  ['/service/operations/accounts', 'brand-account'],
  ['/service/operations/seeding', 'campaign'],
  ['/service/operations/seeding-check', 'influencer-check'],
  ['/service/operations/seeding/[id]', 'campaign'],
  ['/service/post-benchmark', 'post-benchmark'],
  ['/service/request', 'request'],
  ['/service/research/[tab]', 'search-all'],
  ['/service/settings', 'settings'],
  ['/service/start', 'onboarding'],
  ['/service/task-manage', 'jobs'],
  ['/service/thumbnail', 'idea'],
  ['/service/tracking', 'status'],
  ['/service/tracking/brand-mentions', 'brand-mention'],
  ['/service/tracking/brand-mentions/edit', 'brand-mention'],
  ['/service/tracking/search-trend', 'search-trend'],
  ['/service/tracking/target-mentions', 'keyword-monitoring'],
  ['/service/tracking/target-mentions/[id]', 'keyword-monitoring'],
  ['/service/trend', 'trend'],
  ['/service/trend-report', 'trend'],
  ['/service/trending', 'idea'],
  ['/service/view-new', 'view-new'],
  ['/service/weekly', 'weekly'],
  ['/service/workspace', 'workspace'],
  ['/service/workspace/[id]', 'workspace'],
  ['/share/brand/[brand]', 'brand-hub'],
  ['/share/chat/[shareId]', 'search-all'],
  ['/share/creator/[channel]/[account]', 'creator-hub'],
  ['/share/media/[kind]/[id]', 'search-all'],
  ['/shop/[slug]', 'brand-shop'],
  ['/shop/[slug]/c/[campaignId]', 'brand-shop'],
  ['/shop/[slug]/my', 'brand-shop'],
  ['/shop/[slug]/sell', 'brand-shop'],
  ['/subscription/billing/checkout', 'billing'],
  ['/subscription/billing/success', 'billing'],
  ['/subscription/card-change/success', 'billing'],
  ['/subscription/plan', 'billing'],
  ['/subscription/plan-change/checkout', 'billing'],
  ['/subscription/plan-change/success', 'billing'],
  ['/terms/marketing', 'terms'],
  ['/terms/privacy', 'terms'],
  ['/terms/service', 'terms'],
  ['/to/fallback', 'auth'],
  ['/trend', 'marketing-site'],
  ['/trial', 'marketing-site'],
  ['/unipile/complete', 'auth'],
  ['/unsubscribe/mkt', 'terms'],
  ['/updates', 'updates'],
  ['/updates/[slug]', 'updates'],
];
